<template>
  <a target="_blank" :href="link" class="url">{{ link }}</a>
</template>

<script>
export default {
  props: { link: { type: String, required: true } }
}
</script>

<style lang="css" scoped>
  .url { font-family: 'Courier'; font-size: small; }
</style>
